import React from "react"
import { graphql } from "gatsby"

// Components
import { MDXRenderer } from "gatsby-plugin-mdx"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { RiSendPlane2Line, RiQuestionAnswerLine } from "react-icons/ri"

export const pageQuery = graphql`
  query ContactQuery($id: String!) {
    mdx(id: { eq: $id }) {
      id
      body
      excerpt(pruneLength: 140)
      frontmatter {
        title
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`

const Contact = ({ data }) => {
  const { mdx, site } = data
  const { frontmatter, body } = mdx

  return (
    <Layout className="contact-page">
      <SEO
        title={`MSICH — ${frontmatter.title}`}
        description={frontmatter.title + " " + site.siteMetadata.title}
      />
      <div className="wrapper">
        <h1>
          {frontmatter.title}{" "}
          <span className="icon -right">
            <RiQuestionAnswerLine />
          </span>
        </h1>
        <div className="description">
          <MDXRenderer>{body}</MDXRenderer>
        </div>
        <form
          className="contact-form"
          action="/thanks"
          name="contact"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="form-name" value="contact" />
          <p>
            <label>
              Name
              <input type="text" name="name" required />
            </label>
          </p>
          <p>
            <label>
              Email
              <input type="email" name="email" required />
            </label>
          </p>
          <p>
            <label>
              Subject
              <input type="text" name="subject" required />
            </label>
          </p>
          <p>
            <label>
              Message<textarea name="message" required></textarea>
            </label>
          </p>
          <p className="text-align-right">
            <button className="button" type="submit">
              Send it
              <span className="icon -right">
                <RiSendPlane2Line />
              </span>
            </button>
          </p>
        </form>
      </div>
    </Layout>
  )
}

export default Contact
